export const ANALYSIS_NAME_MAX_CHARS = 128;
export const ANALYSIS_DESCRIPTION_MAX_CHARS = 4096;
